import React, { useState } from "react";
import { Form, Input, Button, Space, Card } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
const { forwardRef, useRef, useImperativeHandle } = React;

const MultipleMobile = forwardRef((props, ref) => {
  console.log("mobile props", props);
  const [form] = Form.useForm();
  const [isSave, setIsSave] = useState(null);
  const onFinish = (values) => {
    if (isSave) {
      const mobileData =
        props?.type == "mobile"
          ? values?.mobile_numbers.map((mobile) => ({
              mobile: mobile,
              city: props.city,
              district: props.district,
              userId: props.userid,
              masterId: props.masterId,
            }))
          : values?.addresses.map((addr) => ({
              address: addr.address,
              city: props.city,
              district: props.district,
              userId: props.userid,
              masterId: props.masterId,
            }));

      const data = mobileData;
      const type = props.type;
      // send to parent
      if (props.onMobileFormFiniesh) {
        props.onMobileFormFiniesh(data, type);
      }
    }

    form.resetFields();
  };
  useImperativeHandle(ref, () => ({
    onFinish(falg) {
      setIsSave(falg);
      form.submit();
    },
  }));

  return (
    <Form layout="vertical" hideRequiredMark onFinish={onFinish} form={form}>
      {/* Multiple Mobile Numbers */}

      {props?.type === "mobile" && (
        <Form.List name="mobile_numbers" initialValue={[""]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{ display: "flex", marginBottom: 8 }}
                  align="center"
                >
                  <Form.Item
                    {...restField}
                    name={name}
                    label="Mobile Number"
                    rules={[
                      { required: true, message: "Enter mobile number" },
                      {
                        pattern: /^[0-9]{10}$/,
                        message: "Enter valid 10 digit mobile number",
                      },
                    ]}
                  >
                    <Input
                      onKeyPress={(event) => {
                        if (!/^[0-9]$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      placeholder="Mobile Number"
                      maxLength={10}
                    />
                  </Form.Item>

                  {fields.length > 1 && (
                    <MinusCircleOutlined
                      onClick={() => remove(name)}
                      style={{ fontSize: 18 }}
                    />
                  )}
                </Space>
              ))}

              {fields.length < 5 && (
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    style={{ width: "100%" }}
                  >
                    Add Mobile Number
                  </Button>
                </Form.Item>
              )}
            </>
          )}
        </Form.List>
      )}

      {props?.type === "address" && (
        <Form.List name="addresses" initialValue={[{ address: "" }]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Card
                  key={key}
                  size="small"
                  style={{ marginBottom: 15, border: 0 }}
                >
                  <div style={{ display: "flex", gap: 10 }}>
                    <Form.Item
                      {...restField}
                      name={[name, "address"]}
                      label="Address"
                      style={{ flex: 1 }}
                      rules={[{ required: true, message: "Enter address" }]}
                    >
                      <Input.TextArea rows={3} placeholder="Enter address" />
                    </Form.Item>

                    {fields.length > 1 && (
                      <MinusCircleOutlined
                        onClick={() => remove(name)}
                        style={{ fontSize: 18, marginTop: 40 }}
                      />
                    )}
                  </div>
                </Card>
              ))}

              {fields.length < 5 && (
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                    style={{ width: "100%" }}
                  >
                    Add Address
                  </Button>
                </Form.Item>
              )}
            </>
          )}
        </Form.List>
      )}
    </Form>
  );
});

export default MultipleMobile;
